import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { SvgProps, Circle } from 'react-native-svg';

const CircleIcon = (props: SvgProps & { children?: React.ReactNode }) => (
  <Svg width={40} height={40} fill="none" {...props}>
    <Circle cx={20} cy={20} r={19.722} stroke="#000" strokeWidth={0.556} />
    {props.children && (
      <View style={StyleSheet.absoluteFill}>{props.children}</View>
    )}
  </Svg>
);

export default CircleIcon;
